// extracted by mini-css-extract-plugin
module.exports = {"loadingCenter":"loading-center_loadingCenter__2PZzJ","content":"loading-center_content__3whtl","loadingCont":"loading-center_loadingCont__1rh3h","msg":"loading-center_msg__rvkPB"};